import { render, staticRenderFns } from "./CompanyTypes.vue?vue&type=template&id=24762db7&"
import script from "./CompanyTypes.vue?vue&type=script&lang=js&"
export * from "./CompanyTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports